export default {"src":"/_next/static/media/chat-bubble.8f4be310.svg","height":513,"width":513};